
import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageCTA from "@/components/PageCTA";
import { CTAVariant } from "@/components/PageCTA";

interface ProductPageLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
  keywords: string;
  ctaTitle: string;
  ctaDescription?: string;
  ctaButtonText: string;
  ctaVariant?: CTAVariant;
  showCTA?: boolean;
  onCtaClick?: () => void;
}

const ProductPageLayout: React.FC<ProductPageLayoutProps> = ({
  children,
  title,
  description,
  keywords,
  ctaTitle,
  ctaDescription,
  ctaButtonText,
  ctaVariant = "blue",
  showCTA = true,
  onCtaClick
}) => {
  const scrollToDemo = () => {
    const demoSection = document.getElementById("demo");
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>{title} | Assembly - Employee Recognition Platform</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="Assembly" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://lovable.dev/opengraph-image-p98pqg.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="https://lovable.dev/opengraph-image-p98pqg.png" />
        {typeof window !== 'undefined' && <link rel="canonical" href={window.location.href} />}
      </Helmet>
      
      <div className="flex flex-col min-h-screen w-full bg-[#F7F5FF]">
        <Navbar />
        
        <main className="flex-grow w-full">
          {children}
          
          {/* Page-level CTA */}
          {showCTA && (
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
              <PageCTA
                title={ctaTitle}
                description={ctaDescription}
                buttonText={ctaButtonText}
                variant={ctaVariant}
                onClick={onCtaClick || scrollToDemo}
              />
            </div>
          )}
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default ProductPageLayout;
